<template>
  <FormulateForm
    v-model="user"
    name="login"
    class="accent-form"
    :form-errors="error"
    @submit="handleLogin"
  >
    <FormulateInput
      type="text"
      name="username"
      error-behavior="submit"
      label="E-Mail"
      tabindex="0"
      validation="required"
    />
    <FormulateInput
      type="password"
      name="password"
      error-behavior="submit"
      label="Passwort"
      validation="required"
    />
    <FormulateInput
      type="submit"
      class="span-full"
      :value="loading"
      label="Anmelden"
    />
  </FormulateForm>
</template>

<script>
import User from "@/model/user";
import { errorHandler } from "@/router/utils";

export default {
  name: "LoginForm",
  props: {
    from: {
      type: String,
      default: () => "main",
      required: false,
    },
  },
  data() {
    return {
      error: [],
      user: new User("", ""),
      loading: false,
      message: "",
    };
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.error = [];
      this.$store
        .dispatch("auth/login", { app: this.from, user: this.user })
        .then(() => (this.loading = false))
        .then(() =>
          this.$store.dispatch(
            "auth/refresh",
            this.from === "main" ? "auth-from-main" : "auth-from-icon"
          )
        )
        .then(() => {
          this.$formulate.reset("login");
          if (this.$router) {
            this.$nextTick(() => this.$router.push("/").catch(errorHandler));
          } else {
            window.location.href = "/app/#/";
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response && error.response.status === 401) {
            this.error = ["Nutzerkonto nicht gefunden!"];
          } else {
            this.error = [
              (error.response &&
                error.response.data &&
                error.response.data.reasons &&
                error.response.data.reasons[0]) ||
                error.message ||
                error.toString(),
            ];
          }
          console.error(error);
        });
    },
  },
};
</script>
